import { useNewTranslations } from '@/common/translations';
import { Section } from '@/ui/components';

import {
  TeamsJerseys,
  VictoryProbability as VictoryProbabilityComponent,
} from '../../../components';
import { ApiWidgetType, StatsTypes } from '../../../constants';
import { useStatsData } from '../../../hooks';

const VictoryProbability = () => {
  const translate = useNewTranslations();
  const { teams, widget } = useStatsData({
    widgetType: StatsTypes.VICTORY_PROBABILITY,
  });

  if (!widget || widget.type !== ApiWidgetType.VICTORY_PROBABILITY || !widget?.data) {
    return null;
  }

  const { home: homePercent, away: awayPercent } = widget.data;

  return (
    <Section
      name={translate('PreMatchStats.VictoryProbability')}
      contentClassName="flex flex-col gap-2"
    >
      <TeamsJerseys
        homeJerseySrc={teams.home.jersey}
        awayJerseySrc={teams.away.jersey}
        homeTeamName={teams.home.name}
        awayTeamName={teams.away.name}
      />
      <VictoryProbabilityComponent
        homePercent={homePercent}
        awayPercent={awayPercent}
        homeName={teams.home.name}
        awayName={teams.away.name}
      />
    </Section>
  );
};

export default VictoryProbability;
